import { lazy } from 'react';

// Set webpack public path only when running as a widget (on a different domain)
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const isWidget = !hostname.includes('weticket.co.za') && 
                   hostname !== 'weticket-prod.netlify.app' && 
                   hostname !== 'weticket-dev.netlify.app' && 
                   !hostname.includes('localhost');
  
  if (isWidget && process.env.WIDGET_BASE_URL) {
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = process.env.WIDGET_BASE_URL;
  }
}

const loadSummerFestival = () => import(
  /* webpackChunkName: "summer-festival" */
  'ui/home/summerfestival'
);

export const lazyLoadComponent = (componentName) => {
  if (componentName === 'SeatSelector') {
    return lazy(() => 
      import('ui/components/SeatSelector/SeatSelector').then(module => ({
        default: module.SeatSelector
      }))
    );
  }

  if (componentName === 'SummerFestival') {
    return lazy(() => loadSummerFestival().then(module => ({
      default: module.SummerFestival,
    })));
  }

  if (componentName === 'SummerFestivalEvents') {
    return lazy(() => loadSummerFestival().then(module => ({
      default: module.SummerFestivalEvents,
    })));
  }

  throw new Error(`Component ${componentName} not found`);
};